import { isRejectedWithValue, Middleware } from '@reduxjs/toolkit';
import { log } from '@app/shared/utils/logger';

export const errorLoggerMiddleware: Middleware = () => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const error = new Error(action.error.message, { cause: action.error });
    void log({
      level: 'error',
      message: `apiRequestRejected:${String(action.type)}`,
      error,
      extra: {
        actionType: action.type,
        payload: action.payload,
        meta: action.meta,
      },
    });
  }

  return next(action);
};
